export class CreatePublicationDocumentRequest {
    clubId: string;
    document: File;

    constructor(clubId: string, document: File) {
        this.clubId = clubId;
        this.document = document;
    }
}
